import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IBatchActivitiesCompleteExecutorProps } from './IBatchActivitiesCompleteExecutorProps';
import { BatchActivitiesCompleteExecutorModal } from './BatchActivitiesCompleteExecutorModal';

export const BatchActivitiesCompleteExecutor = createDocModalExecutor<IBatchActivitiesCompleteExecutorProps>({
    modal: BatchActivitiesCompleteExecutorModal,
    defaultModalSize: 'm',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
